/**
 * Theme utility functions for managing light/dark theme
 * Uses cookies to persist theme preference
 */

const THEME_COOKIE_NAME = 'client-desk-theme';
const DEFAULT_THEME = 'dark';
const COOKIE_EXPIRY_DAYS = 365;

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

/**
 * Set a cookie with expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration
 */
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
}

/**
 * Get current theme from cookie or return default
 * @returns {string} Current theme ('dark' or 'light')
 */
export function getTheme() {
    const theme = getCookie(THEME_COOKIE_NAME);
    if (theme === 'dark' || theme === 'light') {
        return theme;
    }
    return DEFAULT_THEME;
}

/**
 * Set theme and apply it to the body element
 * @param {string} theme - Theme to set ('dark' or 'light')
 */
export function setTheme(theme) {
    if (theme !== 'dark' && theme !== 'light') {
        console.warn(`Invalid theme: ${theme}. Using default: ${DEFAULT_THEME}`);
        theme = DEFAULT_THEME;
    }
    
    // Save to cookie
    setCookie(THEME_COOKIE_NAME, theme, COOKIE_EXPIRY_DAYS);
    
    // Remove both theme classes
    document.body.classList.remove('dark-theme', 'light-theme');
    
    // Add the selected theme class
    document.body.classList.add(`${theme}-theme`);
}

/**
 * Toggle between dark and light themes
 * @returns {string} The new theme after toggle
 */
export function toggleTheme() {
    const currentTheme = getTheme();
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    return newTheme;
}

/**
 * Initialize theme on page load
 * Should be called once when the app mounts
 */
export function initTheme() {
    const theme = getTheme();
    setTheme(theme);
}





